import '../../../../../webClient/src/openSite/main-style.scss';

import React, {FunctionComponent} from "react";
import PropTypes from "prop-types";

import "./layout.css";

const Layout: FunctionComponent = ({ children }) => {
    return (
    <>
        <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.7.2/css/all.css"
              integrity="sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr"
              crossOrigin="anonymous"/>
        <link rel='stylesheet' type='text/css' href='//fonts.googleapis.com/css?family=Open+Sans:400,300,700' media='screen' />
        <link href='//fonts.googleapis.com/css?family=Raleway:500,700,300' rel='stylesheet' type='text/css' />
        <link href="https://fonts.googleapis.com/css?family=Muli:400,500,600,700,800,900,900i&display=swap" rel="stylesheet"/>
        <div id="react-dropdown-root"></div>
        <main>{children}</main>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
